import { cva } from "class-variance-authority";

export const buttonVariants = cva(
  "inline-flex shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium " +
    "transition-colors disabled:pointer-events-none disabled:opacity-50 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        primary: "bg-primary text-primary-foreground shadow-sm hover:bg-primary-hover",
        // 2026-10-13: a page's main action, in the banners' gradient.
        hero:
          "bg-[image:var(--hero-brand)] text-white shadow-md shadow-indigo-900/20 " +
          "hover:brightness-110 focus-visible:outline-2 focus-visible:outline-offset-2",
        // On a coloured banner: white, its text in the page's own colour.
        onHero:
          "bg-white text-slate-900 shadow-md hover:bg-white/90 " +
          "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-white",
        secondary: "border border-border bg-card text-foreground shadow-sm hover:bg-muted",
        outline: "border border-input bg-transparent text-foreground hover:bg-muted",
        ghost: "text-foreground hover:bg-muted",
        destructive: "bg-error text-white shadow-sm hover:opacity-90 dark:text-[#1a0b0b]",
        link: "h-auto min-h-0 px-0 text-primary underline-offset-4 hover:underline",
      },
      size: {
        sm: "min-h-8 px-3 text-xs",
        md: "min-h-9 px-3.5",
        lg: "min-h-10 px-5",
        icon: "size-9",
      },
    },
    defaultVariants: { variant: "primary", size: "md" },
  },
);
